'use client';
import { useLocale, useTranslations } from 'next-intl';
import { ComponentProps } from 'react';
import { useShallow } from 'zustand/react/shallow';
import { useVenueAvailabilityStore } from '@/entities/venue/model/venue-availability.store';
import { VenueStatus } from '@/entities/venue/ui/venue-status';

type Props = Pick<ComponentProps<typeof VenueStatus>, 'variant'>;

export const CurrentVenueStatus = ({ variant }: Props) => {
    const t = useTranslations();
    const locale = useLocale();
    const [status, formattedOpeningHours] = useVenueAvailabilityStore(
        useShallow((s) => [s.status, s.formattedOpeningHours]),
    );

    return (
        <VenueStatus
            variant={variant}
            t={t}
            locale={locale}
            openingHours={formattedOpeningHours}
            status={status}
        />
    );
};
